export default "__VITE_ASSET__DCeQWcrd__"